<form [formGroup]="form" nz-form>
    <div class="pf-form-group compact column">
        @if (showPrinterSelectors) {
            <div class="printer-select">
                @if (availablePrinters?.length) {
                    <pf-select
                        label="Available Printers"
                        placeholder="Select a printer"
                        pfStyle="block"
                        [data]="availablePrinters"
                        [pfDisabled]="!!form.value.printer"
                        (selected)="onPrinterSelected($event)"
                        controlName="printerSelect"></pf-select>
                    <span>OR</span>
                }
                <pf-input
                    inputType="text"
                    label="Printer"
                    placeholder="Scan or enter printer address"
                    pfStyle="block"
                    (pfInput)="onPrinterInput($event)"
                    [pfDisabled]="!!form.value.printerSelect"
                    controlName="printer"></pf-input>
            </div>
        } @else {
            <div class="selected-printer">
                <pf-text>Printer: {{ selectedPrinterLabel }}</pf-text>
                <pf-button buttonType="action" (click)="changePrinter()">
                    Change printer
                </pf-button>
            </div>
        }
        @if (hasPrinter()) {
            <div class="printer-memory-options">
                <pf-checkbox
                    label="Remember printer on this device"
                    labelPosition="right"
                    no-margin
                    controlName="remember"></pf-checkbox>
                <pf-checkbox
                    label="Auto-print when opening this screen"
                    labelPosition="right"
                    no-margin
                    controlName="autoPrint"></pf-checkbox>
            </div>
        }
        <pf-input
            inputType="number"
            label="Copies"
            pfStyle="block"
            controlName="copies"></pf-input>
        <pf-text>
            {{ labelCount }} labels x {{ copies }} copies =
            {{ totalLabels }} total labels
        </pf-text>
    </div>
</form>
